import { Loader, MiniTile, DeltaBadge, EmployeeTable, useReport, ExportCsvButton } from "../shared";

export const TipsByEmployeeSection = ({ filter }) => {
  const [data, loading, prevData] = useReport("/reports/tips-by-employee", filter, false);
  if (loading) return <Loader />;
  if (!data) return null;
  const tippedNow = data.employees.filter((e) => e.tip_total > 0).length;
  const tippedPrev = prevData ? prevData.employees.filter((e) => e.tip_total > 0).length : null;
  return (
    <div className="space-y-3" data-testid="tips-section">
      <div className="flex justify-end">
        <ExportCsvButton path="/reports/tips-by-employee/export.csv" filter={filter} isSingleDay={false} testId="export-tips-csv" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <MiniTile
          label="Total Tips"
          value={`$${data.total_tips.toFixed(2)}`}
          tone="text-accent"
          testId="tips-total"
          extra={prevData ? <DeltaBadge current={data.total_tips} previous={prevData.total_tips} /> : null}
        />
        <MiniTile
          label="Employees Tipped"
          value={tippedNow}
          testId="tips-count"
          extra={prevData ? <DeltaBadge current={tippedNow} previous={tippedPrev} /> : null}
        />
      </div>
      <EmployeeTable
        rows={data.employees}
        columns={[
          { key: "server_name", label: "Server", fmt: (v) => v },
          { key: "orders", label: "Orders", fmt: (v) => v, align: "right" },
          { key: "tip_count", label: "Tipped Tickets", fmt: (v) => v, align: "right" },
          { key: "avg_tip", label: "Avg Tip", fmt: (v) => `$${v.toFixed(2)}`, align: "right" },
          {
            key: "tip_total",
            label: "Total Tips",
            fmt: (v) => `$${v.toFixed(2)}`,
            align: "right",
            bold: true,
            accent: true,
          },
        ]}
        testIdPrefix="tips-row"
        emptyText="No tips recorded in this window."
      />
    </div>
  );
};
